import { Command } from "../command";
import { CommandType } from "../commandType";
import * as $ from "jquery";
import { PopupType } from "../popups/popupType";
import { Application } from "../application";
import * as ko from "knockout";
import {EstimateRenamePopupParams} from "../../components/estimate-rename-popup/estimate-rename-popup";

export class RenameCurrentEstimateCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.RenameCurrentEstimate;
    
    canExecute = ko.computed(() => {
        let estimate = this.app.state.estimate();
        
        if(!estimate)
            return false;
        
        return true;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    
    execute(): JQueryPromise<any> {
       
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        let estimate = this.app.state.estimate();
        
        let params = <EstimateRenamePopupParams> {
            id: estimate!.id(),
            name: estimate!.name()
        };
        
        return this.app.popupsManager.show<EstimateRenamePopupParams>(PopupType.estimateRename, false, params).done(() => {
            estimate!.name(params.name);
        });
    }

    name = "Rename estimate";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/renameCurrentEstimateCommand.ts